export function idoModel(ido) {
    const iface = {};

    iface.id = ido.id;
    iface.email = ido.email;
    iface.domain = ido.domain;

    return iface;
}
